import React from 'react';
import { Button } from 'reactstrap';

class QuestionFeedbackButtons extends React.Component {
  state = {
    selectedThumb: null,
    prevoiusVote: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (nextProps.userPreviousVote === 1 || nextProps.userPreviousVote === -1) &&
      !this.state.prevoiusVote
    ) {
      this.setState({ prevoiusVote: true });
      this.setPreviousVote(nextProps.userPreviousVote);
    }
  }

  setPreviousVote = (vote) => {
    this.props.selectThumb(vote === 1);
  };

  render() {
    return (
      <div>
        <div className="relevant-card text-center d-flex justify-content-between">
          <span>Was this question relevant?</span>
          <div className="d-flex justify-content-start">
            <Button
              color="link ml-1"
              onClick={() => this.props.selectThumb(true)}
            >
              <i
                className={
                  this.props.selectedThumb === 'up'
                    ? 'icon-thumb_up active'
                    : 'icon-thumb_up'
                }
              />
            </Button>
            <Button color="link" onClick={() => this.props.selectThumb(false)}>
              <i
                className={
                  this.props.selectedThumb === 'down'
                    ? 'icon-thumb_down active'
                    : 'icon-thumb_down'
                }
              />
            </Button>
          </div>
        </div>
        {this.props.selectedThumb === 'up' && this.props.upVotes > 0 ? (
          <div className="relevant-card-info">
            {this.props.upVotes} airmen voted yes
          </div>
        ) : null}
      </div>
    );
  }
}

export default QuestionFeedbackButtons;
